import Content from "./Home/Content";
import Card from "./Home/Card";
const Home = () => {
  return (
    <div>
      <Content />
      <Card />
    </div>
  );
};

export default Home;
